import React from 'react';
import TrackableListingCard from '../common/TrackableListingCard';
import ListingCardSkeleton from '../common/ListingCardSkeleton';
import { getTierKey } from '../../utils/listingFeatures';
import { buildListingPath } from '../../utils/listingUrls';

function DirectoryResultsGrid({
  listings = [],
  loading = false,
  skeletonCount = 6,
  onViewProfile,
  mapListingToCardListing,
  startIndex = 0,
}) {
  if (loading) {
    return (
      <div className="grid grid-cols-1 gap-4 sm:gap-5">
        {Array.from({ length: skeletonCount }).map((_, index) => (
          <ListingCardSkeleton key={`directory-skeleton-${index}`} />
        ))}
      </div>
    );
  }

  if (!Array.isArray(listings) || listings.length === 0) {
    return null;
  }

  return (
    <div className="grid grid-cols-1 gap-4 sm:gap-5">
      {listings.map((listing, index) => {
        const tier = getTierKey(listing);
        const cardListing = mapListingToCardListing
          ? mapListingToCardListing(listing)
          : listing;
        const targetPath = buildListingPath(listing);

        return (
          <TrackableListingCard
            key={listing.id || `directory-listing-${index}`}
            listingId={listing.id}
            context="/listings"
            section="/listings"
            index={startIndex + index}
            variant="directoryRow"
            tier={tier}
            listing={cardListing}
            targetPath={targetPath}
            onNavigate={onViewProfile ? () => onViewProfile(listing) : undefined}
            analyticsEnabled
          />
        );
      })}
    </div>
  );
}

export default DirectoryResultsGrid;
